import {
    baseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const authAPI = createApi({
    baseQuery: baseQuery,
    reducerPath: 'authAPI',
    endpoints: (builder) => ({

        login: builder.mutation({
            query: ({ skipErrorToast, ...data }) => ({
                url: '/auth/company/login',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        forgotPassword: builder.mutation({
            query: ({ skipErrorToast, ...data }) => ({
                url: '/auth/company/forgot-password',
                method: 'GET',
                params: { username: data.userName }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        resetPassword: builder.mutation({
            query: ({ skipErrorToast, token, ...data }) => ({
                url: '/auth/company/set-password',
                method: 'PUT',
                headers: { Authorization: `Bearer ${token}` },
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
});

export const {
    useLoginMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation
} = authAPI;

export default authAPI;
